const MODULE_NAME = 'QuestionsModule';

export const CHANGE_QUESTIONS_ORDER = `${MODULE_NAME}/CHANGE_QUESTIONS_ORDER`;
export const QUESTIONS_ORDER = `${MODULE_NAME}/QUESTIONS_ORDER`;
export const SET_QUESTIONS = `${MODULE_NAME}/SET_QUESTIONS`;
export const LOCAL_SET_QUESTIONS = 'SET_QUESTIONS';
export const LOCAL_REMOVE_QUESTION = 'REMOVE_QUESTION';
export const LOCAL_UPDATE_QUESTION = 'LOCAL_UPDATE_QUESTION';
